export const GLOSSARY: Record<string, string> = {
  "WBD": "Wellbore Diagram — visual representation of well construction",
  "W-3": "Texas RRC Well Plugging Report form",
  "W-3A": "Texas RRC Application to Plug and Abandon form",
  "C-103": "New Mexico OCD Application for Permit to Plug and Abandon",
  "CIBP": "Cast Iron Bridge Plug — a mechanical barrier set in the wellbore",
  "COA": "Conditions of Approval — regulatory requirements for well plugging",
  "RRC": "Railroad Commission of Texas — state oil & gas regulator",
  "OCD": "Oil Conservation Division (New Mexico) — state oil & gas regulator",
  "API14": "14-digit American Petroleum Institute well identifier",
  "GAU": "Gas Allowable Update — Texas production form",
  "DWR": "Daily Work Report — field activity log",
  "PNA": "Plug and Abandon — the process of permanently sealing a well",
  "WOC": "Wait on Cement — time required for cement to set",
  "UQW": "Usable Quality Water — water zones requiring protection during plugging",
};
